import { useState } from 'react';
import IconFA from '../icon/icon';
import Label from '../label/label';
import Input from '../input/input';
import './passwordInput.css'

const PasswordInput = ({labelFor, labelValue, inputId, inputValue, onChange, required, borderColor = 'black', width= '320px', height= '50px', color='black', fontSize= '1.2rem'}) => {

    const [showPassword, setShowPassword] = useState(false);
    const togglePassword = () => setShowPassword(prev => !prev);

    return (
        <div className='passwordInputContainer'>
            <div className='passwordInputWrapper'>
                <Label labelFor={ labelFor } labelValue={ labelValue } className='passwordInputLabel' />
                <br />
                <div className='passwordInputInputWrapper'>
                    <Input
                        inputType={showPassword ? 'text' : 'password'}
                        inputId={ inputId }
                        inputValue={ inputValue }
                        borderColor={ borderColor }
                        onChange={ onChange }
                        required={ required }
                        width= { width }
                        height= { height }
                        color= { color }
                        fontSize= { fontSize }
                    />

                    <span
                        onClick={ togglePassword }
                        className='passwordInputSpan'
                        aria-label={ showPassword ? 'Passwort verstecken' : 'Passwort anzeigen' }
                    >
                        <IconFA
                            iconName={ showPassword ? 'eyeSlash' : 'eye' }
                            color='black'
                            fontSize='20px'
                        />
                    </span>
                </div>
            </div>
        </div>
    );
};

export default PasswordInput;